import { render, staticRenderFns } from "./ModalEditToDo.vue?vue&type=template&id=2839f9fa"
import script from "./ModalEditToDo.vue?vue&type=script&lang=js"
export * from "./ModalEditToDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports